import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiUsers, FiTrendingUp, FiStar, FiZap } = FiIcons;

const Stats = () => {
  const stats = [
    {
      icon: FiUsers,
      number: '50K+',
      label: 'Happy Customers',
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: FiTrendingUp,
      number: '1M+',
      label: 'Orders Completed',
      color: 'from-green-500 to-green-600'
    },
    {
      icon: FiStar,
      number: '4.9/5',
      label: 'Customer Rating',
      color: 'from-yellow-500 to-yellow-600'
    },
    {
      icon: FiZap,
      number: '24/7',
      label: 'Support Available',
      color: 'from-purple-500 to-purple-600'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="text-center"
            >
              <div className={`inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r ${stat.color} rounded-xl mb-4`}>
                <SafeIcon icon={stat.icon} className="w-8 h-8 text-white" />
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-1">{stat.number}</div>
              <div className="text-gray-600 font-medium">{stat.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;